import type { StatusTransition } from '@atlassian/jira-issue-field-status/src/common/types.tsx';

const shouldReplace = (existing: StatusTransition, replacement: StatusTransition): boolean =>
	(!existing.isInitial && replacement.isInitial) ||
	(existing.isDisabled === true && !replacement.isDisabled);

export const transformData = (data: StatusTransition[]): StatusTransition[] => {
	const transitionMap = data.reduce((acc, val) => {
		if (acc.has(val.to.id) && !shouldReplace(acc.get(val.to.id), val)) {
			return acc;
		}

		return acc.set(val.to.id, val);
	}, new Map());

	return Array.from(transitionMap.values());
};
